import React from "react";
import { Helmet } from "react-helmet-async";
import { absoluteUrl } from "../config/site";

export default function Seo({
  title,
  description,
  pathname,
  lang = "es-PE",
  noIndex = false,
  imagePathname = "/icons/icon-512.png",
  jsonLd,
  ogLocale,
}) {
  const canonical = absoluteUrl(pathname || "/");
  const ogImage = imagePathname ? absoluteUrl(imagePathname) : undefined;
  const locale =
    ogLocale ||
    (lang === "en" || String(lang).startsWith("en") ? "en_US" : "es_PE");
  const hreflang = String(lang).startsWith("en") ? "en" : "es-PE";

  return (
    <Helmet>
      {lang ? <html lang={lang} /> : null}
      {title ? <title>{title}</title> : null}
      {description ? <meta name="description" content={description} /> : null}
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang={hreflang} href={canonical} />
      {noIndex ? (
        <meta name="robots" content="noindex,nofollow" />
      ) : (
        <meta name="robots" content="index,follow" />
      )}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Smile Up" />
      <meta property="og:locale" content={locale} />
      <meta property="og:url" content={canonical} />
      {title ? <meta property="og:title" content={title} /> : null}
      {description ? (
        <meta property="og:description" content={description} />
      ) : null}
      {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
      {title ? <meta name="twitter:title" content={title} /> : null}
      {description ? (
        <meta name="twitter:description" content={description} />
      ) : null}
      {ogImage ? <meta name="twitter:image" content={ogImage} /> : null}
      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}

